import React from "react";
import Dum10Owl from "../../diamondCasinoAllGames/dum10/Dum10Owl";

const IMG = `${import.meta.env.BASE_URL}img/cards`;
const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

// Reference #andarSlider / #baharSlider owl options in the result modal: responsive items, slideBy 5
// (capped to the cards in view), 0.75 s slide, finger drag that snaps to a whole card.
const sliderItems = () => {
  const w = typeof window === "undefined" ? 1920 : window.innerWidth;
  if (w >= 600) return 8;
  if (w >= 500) return 6;
  if (w >= 411) return 5;
  return 4;
};

/**
 * Reference result body for Andar Bahar 50 / 150 cards (CasinoResult "ab3" / "ab4" branch):
 *   .row.row5.ab2-result > .col-12.col-lg-8 > .d-flex > .mr-3.abj-title (A / B) + .col-9
 *     > 2 × .card-inner > .row.row5 > .col-10 (owl of .casino-result-cards-item.item: position + card)
 *       + .col-2 (winner icon on the winning side: win 1 Andar, 2 Bahar)
 *   + .col-12.col-lg-4 (.casino-result-desc "Winner :" rdesc split on "#" [0]).
 * Cards: index even → Bahar, odd → Andar ("1" skipped), key = index + 1.
 */
export default function Ab3ResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const andar = [];
  const bahar = [];
  cards.forEach((c, i) => {
    if (c === "1") return;
    (i % 2 === 0 ? bahar : andar).push({ card: c, key: i + 1 });
  });
  const win = String(t1?.win ?? "");

  const row = (id, list, winner) => (
    <div className="card-inner">
      <div className="row row5">
        <div className="col-10">
          <Dum10Owl
            id={id}
            className="ab-slider owl-carousel owl-theme"
            items={sliderItems()}
            slideBy={Math.min(5, sliderItems())}
            slideMs={750}
            drag
          >
            {list.map((s, i) => (
              <div key={`${i}-${s.card}`} className="casino-result-cards-item item">
                <div className="text-center">{s.key}</div> <img src={`${IMG}/${s.card}.png`} alt="" draggable={false} />
              </div>
            ))}
          </Dum10Owl>
        </div>{" "}
        <div className="col-2">
          {winner ? (
            <div className="casino-result-cards-item">
              <img src={WINNER_IMG} className="winner-icon" alt="" />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );

  return (
    <div className="row row5 ab2-result">
      <div className="col-12 col-lg-8">
        <div className="d-flex">
          <div className="mr-3 abj-title">
            <div className="row row5">
              <div className="col-12">
                <b>A</b>
              </div>
            </div>{" "}
            <div className="row row5">
              <div className="col-12">
                <b>B</b>
              </div>
            </div>
          </div>{" "}
          <div className="col-9">
            {row("andarSlider", andar, win === "1")}{" "}
            {row("baharSlider", bahar, win === "2")}
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length ? (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>
                Winner <span className="float-right">:</span>
              </div>{" "}
              <div>{desc[0]}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
